export default __webpack_public_path__ + "static/media/arrowButton.1ef3d40b.svg";